import { Alert, FormHelperText, Snackbar } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Col, Row } from 'antd';
import Loading from 'components/Loading';
import dayjs from 'dayjs';
import { find, get, map, cloneDeep } from "lodash";
import React, { useEffect, useMemo, useReducer, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { handleListTeacherClasses } from 'store/classes/thunks';
import { useCleverCources } from 'store/clever/selectors';
import { useCurrentOrgPermission } from 'store/organizations/selectors';
import { handleCreateUserClass } from 'store/userClasses/thunks';
import { handleAddStudentWithClass, handleCheckUsername, handleCreateUser, handleUpdateUser } from 'store/users/thunks';
import styled from 'styled-components';
import COLOR from 'utils/constants/color';
import { isBeforTime } from 'utils/methods/math';
import { makeStyles } from 'utils/styles/mui';
import ChangePasswordForm from './changePassword';

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import {
    Button,
    FormControl, FormControlLabel, InputLabel,
    MenuItem,
    Select, Switch, TextField
} from '@mui/material';
import SelectableBookByGroup from 'components/SelectBookByGroup';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { handleGetUsersListForCreateUser } from 'store/organizations/thunks';
import SpinLoader from 'components/Loader/SpinLoader';
import AntdDropdown from 'components/UI/AntdDropdown';
import useActiveStudentofParent from 'components/hooks/parent/activeStudentofParent';
import usePermissionForUser from 'components/hooks/permissions/usePermissionForUser';
const super_admin = [
    {
        label: 'Owe Admin',
        value: 'owe_admin'
    },
    {
        label: 'District Admin',
        value: 'admin'
    },
    {
        label: 'Teacher',
        value: 'teacher'
    },
    {
        label: 'Student',
        value: 'student'
    },
    {
        label: 'Parent',
        value: 'parent'
    },
]
const dist_admin = [
    {
        label: 'Placement Exam Admin',
        value: 'placement_admin'
    },
    {
        label: 'Teacher',
        value: 'teacher'
    },
    {
        label: 'Student',
        value: 'student'
    }
]
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const Description = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 48px;
`;

const Header = styled(Description)`
    color: ${COLOR.black100};
    font-size: 28px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 16px;
`;

const Wrapper = styled.form`
    margin: 0px auto;
	// max-width: 480px;
    width: 100%;
`;

const BookSection = styled.div`
    width: 100%;
`

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: '2px',
        minWidth: 120
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    noLabel: {
        marginTop: '8px',
    },
    rootDif: {
        width: '200px'
    },
    rootDifFull: {
        width: "100%"
    },
    sizeSmall: {
        width: '55px',
        height: '25px'
    },
    checkedSwitch: {
        transform: 'translateX(30px) !important'
    },


    label: {
        textTransform: 'uppercase',
    },
}));


//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Class form
//
//  -- Description
//  ...
//
//  -- Props
//  ...
//
const UserForm = ({
    userData,
    editing,
    onClose,
    schools,
    onlyAdd,
    currentOrg,
    currentUser,
    userBook
}) => {
    let showBooksInitial = false;
    const permissions = useCurrentOrgPermission()
    const bookPermissions_group = useMemo(() => get(permissions, "books_group_permission", []), [permissions])
    const cleverCources = useCleverCources()
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const [showBooks, setShowBooks] = useState(showBooksInitial);
    const dispatch = useDispatch();
    const [data, setData] = useState(editing ? userData : {});
    const [loading, setLoading] = useState(false);
    const [viewChangePassword, setViewChangePassword] = useState(false);
    const [createUserError, setCreateUserError] = useState(null)
    const [isDemo, setDemo] = useState(false)
    const [open, setOpen] = React.useState(false);
    const [popupMessage, setPopupMessage] = React.useState('');
    const roles = useMemo(()=>get(currentUser, 'role', '') == 'admin'?dist_admin:super_admin,[currentUser])
    const [teacherList,setTeacherList] = useState([]);
    const [studentList,setStudentList] = useState([]);
   
    function showChangePassword() {
        setViewChangePassword(true)
    }

    function hiddenChangePassword(option) {
        if (option) {
            setViewChangePassword(false);
            onClose();
        } else {
            setViewChangePassword(false);
        }
    }
    const classes = useStyles();
    const [roleError, setRoleError] = useState(false);
    const [schoolError, setSchoolError] = useState(false);
    const [userError, setUserError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [formatPasswordError, setFormatPasswordError] = useState(false);
    const [firstNameError, setFirstNameError] = useState(false);
    const [firstNameCharError, setFirstNameCharError] = useState(false);
    const [lastNameError, setLastNameError] = useState(false);
    const [lastNameCharError, setLastNameCharError] = useState(false);
    const [gradeError, setGradeError] = useState(false);
    const [booksError, setBooksError] = useState(false);
    const [usernameError, setUsernameError] = useState(false);
    const [noLicensesError, setNoLicensesError] = useState(false);
    const [teacherStdError, setTeacherStdError] = useState(false);
    const [parentStdError, setparentStdError] = useState(false);
    const [classStdError, setClassStdError] = useState(false)
    const [typeOrg, setTypeOrg] = useState('NoSet');
    const [showDemo, setShowDemo] = useState(false)
    const [isClaver, setIsClaver] = useState(false)
    const [userClasses, setuserClasses] = useState([])
    const [teacherClass, setTeacherClass] = useState([])
    const [selectedTeacher, setSelectedTeacher] = useState('')
    const [selectedStudentForParent, setselectedStudentForParent] = useState('')
    const [selectedClass, setSelectedClass] = useState('')
    const [teacherClassLoader, setTeacherClassloader] = useState(false)
    const [findClassBook, setFindClassBook] = useState()
    const [selectedBook, setSelectedBook] = React.useState([]);
    const showAlert = useAlert();
  	const navigate = useNavigate();
    const [data_loader,setLoader] = useState(false)
    const { activeStudentParent } = useActiveStudentofParent();
    const {checkUserExist} = usePermissionForUser();
    const [emailError, setEmailError] = useState(false);
    useEffect(()=>{
        if(userBook&&userBook.id){
            setSelectedBook(userBook.books_group)
        }
    },[userBook])
    useEffect(() => {
        if (get(currentOrg, "cleverId")) {
            setIsClaver(true)
        } else {
            setIsClaver(false)
        }
    }, [currentOrg])
    useEffect(() => {
        if (userData?.role == 'student' || userData?.role == 'teacher' || userData?.role == 'director' || userData?.role == 'parent') {
            setTypeOrg('school');
        }
        else {
            setTypeOrg('district');
        }
        if (editing && userData) {
            setDemo(userData.demo)
            setselectedStudentForParent(activeStudentParent)
            setShowBooks(userData.role == "teacher")
            setData(userData)
            if (userData.role == "teacher" || userData.role == 'student') {
                setShowDemo(true)
            }
        }else{
             setData(userData)
             setShowBooks(userData?.role == "teacher")
             forceUpdate()
        }

    }, [userData])
    const getUsersList = async () => {
        try {
            if (data.role == "parent" && data.orgId) {
                const dt = await handleGetUsersListForCreateUser(data.orgId, "student")
                if (dt && dt.success) {
                    setStudentList(dt.data)
                }

            } else if (data.role == "student") {
                const dt = await handleGetUsersListForCreateUser(data.orgId, "teacher")
                if (dt && dt.success) {
                    setTeacherList(dt.data)
                }

            }
        } catch (error) {

        } finally {
            setLoader(false)
        }

    }
    useEffect(() => {
        getUsersList()
    }, [data?.role, data?.orgId])

    const handleChange = e => {
        var validation = e.target.value?.length >= 50;
        if (e.target.id == 'firstName') {
            if (validation) {
               setFirstNameCharError(true);
            } else {
                setFirstNameError(false);
                setFirstNameCharError(false);
            }
        }
        if (e.target.id == 'lastName') {
            if (validation) {
                setLastNameCharError(true);
             } else {
                setLastNameError(false);
                setLastNameCharError(false);
             }
        }
        if (e.target.id == 'grade') {
            setGradeError(false);
        }
        setData({
            ...data,
            [e.target.id]: e.target.value
        });
    };
    const handleUpdateData = (key, value) => {
        const resp = data;
        resp[key] = value;
        setData(resp)
        forceUpdate()
    }
    const handleSelect = (id, value) => {
        if (id == 'role') {
            if (!['owe_admin','parent'].includes(value)) {
                setShowBooks(true);
            }
            else {
                setShowBooks(false);
            }
            if (value == "teacher") {
                setShowDemo(true)
            } else {
                setShowDemo(false)
            }
            setRoleError(false);

            if (value == 'student' || value == 'teacher' || value == 'director' || value == 'parent') {
                setTypeOrg('school');
            }
            else {
                setTypeOrg('district');
            }
        }


        if (id == 'orgId') {
            setSchoolError(false);
        }
        if (id == 'teacherForStd') {
            setTeacherStdError(false);
        }
        if(id==="parent_of"){
            setparentStdError(false);
        }
        if (id == 'classForStd') {
            setClassStdError(false)
        }
        setData({
            ...data,
            [id]: value
        });
    };
    const getStartMintime = (value) => {
        if (get(data, "editing") && value) {
            return isBeforTime(dayjs(value).toISOString())
                ? dayjs()
                : dayjs(value);
        } else {
            return dayjs();
        }
    }
    const navigateToDataBrowser = () =>{
        navigate(`/data-browsers${data.role?"?tab="+data.role:''}`)
    }
    const onSubmit = async (e) => {
        e.preventDefault();
        setCreateUserError(null);
        // setLoading(true);
        const effectiveOrgId = typeOrg === 'district' ? currentOrg?.id : data?.orgId;
     if(!editing){
        const [checkUserName, checkEmail] = await Promise.all([
            checkUsername(data.username),
            checkUserExist(data.email),
        ])
        if(checkEmail){
            setEmailError(true);
            setLoading(false);
            return;
        }else{
            setEmailError(false);
        }
        if(checkUserName && !editing){
            showAlert('User is already exist with this username', 'error');
            setLoading(false);
            return;
        }
        }
        let allForm = true;
        allForm = validInput('role');
        allForm = validInput('orgId', effectiveOrgId);
        if(!allForm){
            showAlert('Please fill all the required fields', 'error');
            return;
        }
        allForm = validInput('username');
        allForm = validInput('firstName');
        allForm = validInput('lastName');
        if (validInput('role')) {
            if(data.role ==='parent'){
                allForm = validInput('parent_of');
            }
            if (data.role != 'student') {
                if (!editing) {
                    allForm = validInput('password');
                }
            } else {
                allForm = validInput('grade');
                if(!data?.username){
                    allForm = false;
                }
                // if(editing){
                //     allForm = validInput('class_names')
                //     allForm = validInput('teacher_full_name');
                // }else{
                //     allForm = validInput('classForStd')
                //     allForm = validInput('teacherForStd');
                // }
            }
        }
   
        if (allForm) {
            var booksUser = {};
            if (data.role == 'teacher' ) {
                if (selectedBook.length > 0) {
                    setBooksError(false);
                    booksUser = {
                        "books_group": selectedBook,
                        "userId": "",
                        "orgId": data.orgId
                    }
                    setLoading(true);
                    if (editing) {
                       const updatedUser = await dispatch(handleUpdateUser(userData.id, {...userData,...data},booksUser,userBook?.id));
                        if(updatedUser?.statusCode === 500){
                            showAlert("User already exist with same username", "error");
                            setLoading(false);
                            return;
                        } 
                       navigateToDataBrowser()
                    } else {
                            const newUser = await dispatch(handleCreateUser({
                                auth: {
                                    username: data.username,
                                    password: data.password,
                                },
                                user: {
                                    firstName: data.firstName,
                                    lastName: data.lastName,
                                    orgId: effectiveOrgId,
                                    role: data.role,
                                    demo: data.demo,
                                    startDate: data.startDate,
                                    endDate: data.endDate,
                                    cleverId: data.cleverId,
                                    email: data.email,
                                },
                                userBooks: booksUser
                            }));
                            if(newUser?.statusCode === 500){
                                showAlert("User already exist with same username", "error");
                                setLoading(false);
                                return;
                            }
                            if (newUser && !newUser.error) {
                                await assignClassToStudent(newUser)
                                navigateToDataBrowser()
                            } else {
                                if (newUser.error && newUser.message) {
                                    setCreateUserError(newUser.message || "Something went wrong!")
                                } 
                            }
                    }
                    setLoading(false);
                } else {
                    if (isClaver) {
                        setOpen(true)
                        showAlert("Please add atleast one cources", "info")
                        setPopupMessage("Please add atleast one cources")
                    } else {
                        showAlert("Choose at least one book", "info")
                        setBooksError(true);
                    }

                }
            }
            else if (data.role == 'student') {
                if(!editing){
                    setLoading(true);
                const BooksLength = findClassBook?.books_group ?? ''
                const createStudent = await dispatch(handleAddStudentWithClass({
                    classId: selectedClass,
                    books: BooksLength,
                    username: get(data, "username", ''),
                    password: get(data, 'password', ''),
                    firstName: get(data, "firstName", ''),
                    lastName: get(data, "lastName", ''),
                    grade: get(data, "grade", ''),
                    orgId: effectiveOrgId,
                    email: data.email,
                }))
                 if(createStudent?.statusCode === 500){
                    showAlert("User already exist with same username", "error");
                    setLoading(false);
                    return;
                }
                if (createStudent && !createStudent.error) {
                    setLoading(false);
                    navigateToDataBrowser()
                } else {
                    if (createStudent.error && createStudent.error.code == "UsernameExistsException") {
                        showAlert(" Please, create the user again with a new username. ", "info")
                        setCreateUserError(" Please, create the user again with a new username. ")
                    } else {
                        showAlert(createStudent.message || "Something went wrong!", "info")
                        setCreateUserError(createStudent.message || "Something went wrong!")
                    }
                    setLoading(false);
                }  
                }
                else {
                    setLoading(true);
                    if (editing) {
                        const updatedUser = await dispatch(handleUpdateUser(userData.id, { ...userData, ...data}, booksUser, userBook?.id));
                        if(updatedUser?.statusCode === 500){
                            showAlert("User already exist with same username", "error");
                            setLoading(false);
                            return;
                        }
                        navigateToDataBrowser()
                    } else {
                        const newUser = await dispatch(handleCreateUser({
                            auth: {
                                username: data.username,
                                password:  data.password,
                            },
                            user: {
                                firstName: data.firstName,
                                lastName: data.lastName,
                                orgId: effectiveOrgId,
                                role: data.role,
                                parent_of:data.parent_of,
                                email: data.email,
                            },
                            userBooks: booksUser
                        }));
                        if(newUser?.statusCode === 500){
                            showAlert("User already exist with same username", "error");
                            setLoading(false);
                            return;
                        }
                        if (newUser && !newUser.error) {
                            navigateToDataBrowser()
                        } else {
                            if (newUser.error && newUser.message) {
                                setCreateUserError(newUser.message || "Something went wrong!")
                            } 
                        }
                    }
                    setLoading(false);
                }
            }
            else {
                setLoading(true);
                if (editing) {
                    const updatedUser = await dispatch(handleUpdateUser(userData.id, {...userData, ...data}, booksUser, userBook?.id));
                     if(updatedUser?.statusCode === 500){
                        showAlert("User already exist with same username", "error");
                        setLoading(false);
                        return;
                        }
                    navigateToDataBrowser()
                } else {
                    const newUser = await dispatch(handleCreateUser({
                        auth: {
                            username: data.username,
                            password:  data.password,
                        },
                        user: {
                            firstName: data.firstName,
                            lastName: data.lastName,
                            orgId: effectiveOrgId,
                            role: data.role,
                            parent_of:data.parent_of,
                            email: data.email,
                            user_sub_roles: data?.user_sub_roles || null,
                        },
                        userBooks: booksUser
                    }));
                     if(newUser?.statusCode === 500){
                            showAlert("User already exist with same username", "error");
                            setLoading(false);
                            return;
                        }
                    if (newUser && !newUser.error) {
                        navigateToDataBrowser()
                    } else {
                        if (newUser.error && newUser.message) {
                            setCreateUserError(newUser.message || "Something went wrong!")
                        } 
                    }
                }
                setLoading(false);
            }
           
        }
    };

    const assignClassToStudent = async (student) => {
        const studentId = get(student, "user.id", '')
        if(selectedClass)
        await dispatch(handleCreateUserClass({ userId: studentId, classId: selectedClass }))

    }
    const checkUsername = async (value) => {
        const nameCheck = await dispatch(handleCheckUsername(value));

        if (nameCheck) {
            return true;
        } else {
            return false;
        }
    };
    const getClassForTeacher = async (teacherId) => {
        setTeacherClassloader(true)
        setSelectedClass('')
        const teacherClassData = await dispatch(handleListTeacherClasses(teacherId))
        setTeacherClass(teacherClassData)
        setTeacherClassloader(false)
    }

    const getClassesBook = (value) => {
        const getClasses = find(teacherClass, obj => obj.id == value);
        setFindClassBook(getClasses)
    }
    const usernameValidation = (e) => {
        var validation = /^[0-9a-zA-Z]+$/;
        if (e.target.value === "" || validation.test(e.target.value)) {
            setUserError(false);
            handleChange(e);
        }
    };

    const passwordValidation = (e) => {
        if (e.target.value != "") {
            setPasswordError(false);
            setFormatPasswordError(false);
        }
        handleChange(e);
    };


    const handleChangeMultiSelect = (value) => {
        setBooksError(false);
        setNoLicensesError(false);
        setSelectedBook(value)
    };



    function validInput(input, overrideValue) {
        switch (input) {
            case 'role':
                if (data.role == undefined || data.role == null || data.role == '') {
                    setRoleError(true);
                    return false;
                } else {
                    setRoleError(false);
                    return true;
                }
            case 'orgId':
                const orgValue = overrideValue !== undefined ? overrideValue : data.orgId;
                if (orgValue == undefined || orgValue == null || orgValue == '') {
                    setSchoolError(true);
                    return false;
                } else {
                    setSchoolError(false);
                    return true;
                }
            case 'username':
                if (data.username == undefined || data.username == null || data.username == '') {
                    setUserError(true);
                    return false;
                } else {
                    setUserError(false);
                    return true;
                }
            case 'password':
                if (data.password == undefined || data.password == null || data.password == '') {
                    setPasswordError(true);
                    return false;
                } else {
                    setPasswordError(false);
                    var paswd = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
                    if (data.password.match(paswd)) {
                        setFormatPasswordError(false);
                        return true;
                    } else {
                        setFormatPasswordError(true);
                        return false;
                    }
                }
            case 'firstName':
                if (data.firstName == undefined || data.firstName == null || data.firstName == '') {
                    setFirstNameError(true);
                    return false;
                } else if (data.firstName?.length >= 50){
                    setFirstNameCharError(true);
                    return false;
                } else {
                    setFirstNameError(false);
                    setFirstNameCharError(false);
                    return true;
                }
            case 'lastName':
                if (data.lastName == undefined || data.lastName == null || data.lastName == '') {
                    setLastNameError(true);
                    return false;
                } else if (data.lastName?.length >= 50){
                    setLastNameCharError(true);
                    return false;
                } else {
                    setLastNameError(false);
                    setLastNameCharError(false);
                    return true;
                }
            case 'grade':
                if (data.grade == undefined || data.grade == null || data.grade == '') {
                    setGradeError(true);
                    return false;
                } else {
                    setGradeError(false);
                    return true;
                }
            case 'teacher_full_name':
                if (data.teacher_full_name == undefined || data.teacher_full_name == null || data.teacher_full_name == '') {
                    setTeacherStdError(true);
                    return false;
                } else {
                    setTeacherStdError(false);
                    return true;
                }
            case 'parent_of':
                if(!selectedStudentForParent){
                    setparentStdError(true)
                    return false;
                }else{
                    setparentStdError(false)
                    return true;
                }
            case 'class_names':
                if (data.class_names == undefined || data.class_names == null || data.class_names == '') {
                    setClassStdError(true);
                    return false;
                } else {
                    setClassStdError(false);
                    return true;
                }
            case 'classForStd':
                if (data.classForStd == undefined || data.classForStd == null || data.classForStd == '') {
                    setClassStdError(true);
                    return false;
                } else {
                    setClassStdError(false);
                    return true;
                }
            case 'teacherForStd':
                if (data.teacherForStd == undefined || data.teacherForStd == null || data.teacherForStd == '') {
                    setTeacherStdError(true);
                    return false;
                } else {
                    setTeacherStdError(false);
                    return true;
                }
            default:
                return false;
        }
    }
    const handleClose = () => {
        setOpen(false);
    };

    const submitValidation = () => {
        if (loading || booksError || noLicensesError || gradeError || lastNameError || lastNameCharError || firstNameError || firstNameCharError || passwordError || formatPasswordError || parentStdError) {
            return true;
        } else if (data.role == undefined || data.role == null || data.role == '') {
            return true;
        } else if (data.orgId == undefined || data.orgId == null || data.orgId == '') {
            return true;
        } else if (data.username == undefined || data.username == null || data.username == '') {
            return true;
        } else if (data.password == undefined || data.password == null || data.password == '') {
            return true;
        } else if (data.firstName == undefined || data.firstName == null || data.firstName == '') {
            return true;
        } else if (data.lastName == undefined || data.lastName == null || data.lastName == '') {
            return true;
        } else if (data.grade == undefined || data.grade == null || data.grade == '') {
            return true;
        } else {
            return false;
        }
    }

    const checkClassExistOrNot = useMemo(() => {
        if (data?.role === "student" && !editing) {
          return (
            !data?.orgId || data.orgId.length === 0 ||
            !data?.role || data.role.length === 0 ||
            !selectedTeacher || selectedTeacher?.trim().length === 0 ||
            !selectedClass || selectedClass?.trim().length === 0 ||
            !data?.username || data.username?.trim().length === 0 ||
            !data?.lastName || data.lastName?.trim().length === 0 ||
            !data?.firstName || data.firstName?.trim().length === 0 ||
            !data?.password || data.password?.trim().length === 0 ||
            !data?.grade || data.grade?.trim().length === 0 
          );
        }
        else if (data?.role === "student" && editing) {
            return (
              !data?.lastName || data.lastName?.trim().length === 0 ||
              !data?.firstName || data.firstName?.trim().length === 0 ||
              !data?.grade || data.grade?.trim().length === 0
            );
          }
        return false;
      }, [data, selectedTeacher, selectedClass]);

      
    const menuNav = () => {
      const menu = [
         {
          key: '',
          label: 'Unselect',
        },
        {
          key: 'coach',
          label: 'coach',
        },
      ];
      return {
        items: menu,
        onClick: (e) => handleSelect('user_sub_roles', e.key),
      };
    };

    const RenderChangeUserSubRole = ({ user }) => {
      return (
        <AntdDropdown menuNav={menuNav()}>
          {data?.user_sub_roles ? user?.user_sub_roles : 'User Sub Role'}
        </AntdDropdown>
      );
    };

    const checkUserExistEmail = async (email) => {
        const isUserExist = await checkUserExist(email);
        if (isUserExist) {
            setEmailError(true);
        } else {
            setEmailError(false);
        }
    }

    return (
        <>
        <SpinLoader dataloader={data_loader} />
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}>
                <Alert onClose={handleClose} severity="error">
                    <strong>ALERT:</strong> {popupMessage}
                </Alert>
            </Snackbar>
            {viewChangePassword && (
                <Wrapper>
                    <ChangePasswordForm
                        userData={userData}
                        loading={loading}
                        onClosed={() => {
                            hiddenChangePassword(true)
                        }}
                        onCancelled={() => {
                            hiddenChangePassword(false)
                        }}
                    />
                </Wrapper>
            )}
            {!viewChangePassword && (
                <Wrapper onSubmit={onSubmit}>
                    <Header style={{ borderColor: COLOR.black100 }}>{editing ? 'Update User' : 'Create User'}</Header>
                    <Row className='fixAdminInputUser' gutter={[24, 24]} style={{ width: '100%', marginTop: 50 }}>
                        <Col span={12} className={"floatingLabelBG"}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel id="roleLabel"  style={{ borderColor: COLOR.black100 }}>Select a Role</InputLabel>
                                <Select
                                    labelId="roleLabel"
                                    id="role"
                                    value={data.role || ''}
                                    onChange={e => handleSelect('role', e.target.value)}
                                    label="Select a Role"               // ← here!
                                    disabled={editing}
                                >
                                    {roles.map(r => (
                                        <MenuItem key={r.value} value={r.value}>
                                            {r.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {roleError &&
                                    <FormHelperText error>Role required</FormHelperText>
                                }
                            </FormControl>
                        </Col>
                        {!editing && (
                            <Col span={12} className={"floatingLabelBG"}>
                                {get(data, "role") !== "owe_admin" && get(data, "role") !== "admin" && data?.role!=='placement_admin'&& (
                                <FormControl variant="outlined">
                                    <InputLabel id="schoolLabel">{typeOrg == 'school' ? 'Select School' : 'Select Organization'}</InputLabel>
                                        <Select
                                            labelId="schoolLabel"
                                            id="orgId"
                                            onChange={e => {
                                                setSelectedClass('')
                                                setSelectedTeacher('')
                                                handleSelect('orgId', e.target.value)
                                            }}
                                            value={data?.orgId}

                                        >
                                            {schools?.map(school => (
                                                <MenuItem key={school.id} value={school.id} >
                                                    {school.displayName}
                                                </MenuItem>
                                            ))}
                                            {typeOrg == 'NoSet' &&
                                                <MenuItem key='noSet' value='noSet' >
                                                    Select a User Role
                                                </MenuItem>
                                            }
                                        </Select>
                                    {schoolError &&
                                        <FormHelperText error>
                                            {typeOrg == 'school' ? 'School is required' : 'Organization is required'}
                                        </FormHelperText>
                                    }
                                </FormControl>
                                )}
                            </Col>
                        )}
                    </Row>
                    {get(data, "role") === "student" && !editing && get(data, "orgId", null) && (
                        <Row className='fixAdminInputUser' gutter={[24, 24]} style={{ width: '100%', marginTop: 18 }}>
                            <Col span={12} className={"floatingLabelBG"}>
                                <FormControl variant="outlined">
                                    <InputLabel id="cleverTeacherLavel" style={{ borderColor: COLOR.black100 }}>Select Teacher for student </InputLabel>
                                    <Select
                                        labelId="cleverCourseLever"
                                        id="cleverCourse"
                                        onChange={e => {
                                            getClassForTeacher(e.target.value)
                                            setSelectedTeacher(e.target.value)
                                            handleSelect('teacherForStd', e.target.value)
                                        }}
                                        value={selectedTeacher}
                                    // className={"schoolForm"}
                                    >
                                        {map(teacherList, teacherd => (
                                            <MenuItem key={teacherd.id} value={teacherd.id} >
                                                {teacherd.lastName || ''} {teacherd.firstName || ''}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {teacherStdError &&
                                        <FormHelperText error>Teacher required</FormHelperText>
                                    }
                                </FormControl>
                            </Col>
                            <Col span={12} className={"floatingLabelBG"}>
                                <FormControl variant="outlined">
                                    <InputLabel id="cleverTeacherLavel">Select Class for student </InputLabel>
                                    {teacherClassLoader ? <Loading /> : <Select
                                        labelId="cleverCourseLever"
                                        id="cleverCourse"
                                        onChange={e => {
                                            setSelectedClass(e.target.value);
                                            handleSelect('classForStd', e.target.value)
                                            getClassesBook(e.target.value)
                                        }}
                                        value={selectedClass}
                                    // className={"schoolForm"}
                                    >
                                        {teacherClass?.map(classd => (
                                            <MenuItem key={classd.id} value={classd.id} >
                                                {classd.displayName}
                                            </MenuItem>
                                        ))}
                                    </Select>}
                                    {classStdError &&
                                        <FormHelperText error>Class required</FormHelperText>
                                    }
                                </FormControl>
                            </Col>
                        </Row>
                    )}
                    {!data.editing && (
                        <Row className='fixAdminInputUser' gutter={[24, 24]} style={{ width: '100%', marginTop: 20 }}>
                            <Col span={12} className={"floatingLabelBG"}>
                                <TextField
                                    // error={usernameError}
                                    id="username"
                                    // onBlur={checkUsername}
                                    onChange={usernameValidation}
                                    label="User ID"
                                    variant="outlined"
                                    value={data?.username}
                                    disabled={editing}
                                    // className={"schoolForm"}
                                    style={{ borderColor: COLOR.black100 }}
                                    // helperText={usernameError && 'Username not available'}
                                />
                                {userError &&
                                    <FormHelperText error>Username required</FormHelperText>
                                }
                            </Col>
                            {(!editing) && (
                                <Col span={12} className={"floatingLabelBG"}>
                                    <TextField
                                        id="password"
                                        onChange={passwordValidation}
                                        label="Password"
                                        variant="outlined"
                                        // className={"schoolForm"}
                                        style={{ borderColor: COLOR.black100 }}
                                    />
                                    {passwordError &&
                                        <FormHelperText error>Password required</FormHelperText>
                                    }
                                    {formatPasswordError &&
                                        <FormHelperText error>Use 8 to 15 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit and one special character.</FormHelperText>
                                    }
                                </Col>
                            )}
                        </Row>
                    )}
                    <Row className='fixAdminInputUser' gutter={[24, 24]} style={{ width: '100%', marginTop: 20 }}>
                        <Col span={data.role === 'student' ? 10 : 12} className={"floatingLabelBG"}>
                            <TextField
                                id="firstName"
                                onChange={handleChange}
                                label="First Name"
                                variant="outlined"
                                value={data?.firstName ?? ' '}
                                // className={"schoolForm"}
                                style={{ borderColor: COLOR.black100 }}
                            />
                            {firstNameError &&
                                <FormHelperText error>First name required</FormHelperText>
                            }
                            {firstNameCharError && 
                                <FormHelperText error>First name cannot exceed 50 characters.</FormHelperText>
                            }
                        </Col>
                        <Col span={data.role === 'student' ? 10 : 12} className={"floatingLabelBG"}>
                            <TextField
                                id="lastName"
                                onChange={handleChange}
                                label="Last Name"
                                variant="outlined"
                                value={data?.lastName ?? ' '}
                                // className={"schoolForm"}
                                style={{ borderColor: COLOR.black100 }}
                            />
                            {lastNameError &&
                                <FormHelperText error>Last name required</FormHelperText>
                            }
                            {lastNameCharError && 
                                <FormHelperText error>Last name cannot exceed 50 characters.</FormHelperText>
                            }
                        </Col>
                        {data.role === 'student' && (
                            <Col span={4} className={"floatingLabelBG"}>
                                <TextField
                                    id="grade"
                                    onChange={handleChange}
                                    label="Grade"
                                    variant="outlined"
                                    value={data?.grade ?? ' '}
                                    // className={"schoolForm"}
                                    style={{ borderColor: COLOR.black100 }}
                                />
                                {gradeError &&
                                    <FormHelperText error>Grade required</FormHelperText>
                                }
                            </Col>
                        )}
                    </Row>
                    {showDemo && <Row className='fixAdminInput floatingLabelBG' justify="start" style={{ marginBottom: 10, marginLeft: 5, marginTop: 20 }}>
                        <FormControlLabel
                            classes={{
                                root: classes.rootDif,
                                label: classes.label,
                            }}
                            control={
                                <Switch
                                    classes={{
                                        sizeSmall: classes.sizeSmall,
                                        checked: classes.checkedSwitch
                                    }}
                                    className={"schoolForm"}
                                    checked={isDemo}
                                    id="demo"
                                    onChange={e => {
                                        setDemo(e.target.checked)
                                        let event = { target: { id: "demo", value: e.target.checked } }
                                        handleChange(event)
                                    }}
                                    name="demo"
                                    color="primary"
                                    size="small"
                                />
                            }
                            // className={"schoolForm"}
                            label="Demo Account"
                        />
                    </Row>}
                     {/* if user is parent */}
                     {get(data, "role") === "parent"  && get(data, "orgId", null) && Boolean(studentList) && (
                        <Row className='fixAdminInputUser'  gutter={[24, 24]}  style={{ width: '100%', marginTop: 18 }}>
                            <Col span={12} className={"floatingLabelBG"}>
                                <FormControl variant="outlined">
                                    <InputLabel id="cleverTeacherLavel" style={{ borderColor: COLOR.black100 }}>Select Student for parent </InputLabel>
                                    <Select
                                        labelId="cleverCourseLever"
                                        id="parent_of"
                                        disabled={editing}
                                        onChange={e => {
                                            handleSelect('parent_of', e.target.value)
                                            setselectedStudentForParent(e.target.value)
                                        }}
                                        value={selectedStudentForParent}
                                    >
                                        {map(studentList, student => (
                                            <MenuItem key={student.id} value={student.id} >
                                                {student.lastName || ''} {student.firstName || ''}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {parentStdError &&
                                        <FormHelperText error>Student required</FormHelperText>
                                    }
                                </FormControl>
                            </Col>
                        </Row>
                    )}
                    {get(data, "role") === "teacher" || get(data, "role") === "student" || get(data, "role") === "admin" ? <Row className='fixAdminInputUser' gutter={[24, 24]} style={{ width: '100%', marginTop: 20 }}>
                        <Col span={12} className={"floatingLabelBG"}>
                            <TextField
                                id="email"
                                onChange={handleChange}
                                label="email"
                                variant="outlined"
                                value={data?.email ?? ' '}
                                type="email"
                                // className={"schoolForm"}
                                style={{ borderColor: COLOR.black100 }}
                                onBlur={(e) => {
                                    checkUserExistEmail(e.target.value)
                                }}
                                error={emailError}
                            />
                    {emailError &&
                            <FormHelperText error>Email already exist</FormHelperText>
                        }   
                        </Col>
                       
                    </Row> : null}
                    <Row  className='fixAdminInput'gutter={[24, 24]} style={{ width: '100%', marginTop: 20 }}>
                        <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                            <DatePicker
                                label="Start Date"
                                value={get(data, "startDate") ? dayjs(get(data, "startDate")) : dayjs()}
                                onChange={(newValue) => {
                                    handleUpdateData('startDate', newValue ? newValue.toISOString() : null);
                                }}
                                inputFormat="MM-DD-YYYY"
                                defaultValue={dayjs()}
                                slotProps={{
                                    textField: {
                                        id: "startDate",
                                        variant: 'outlined',
                                        size: 'small',
                                        InputLabelProps: {
                                            shrink: true,
                                        }
                                    }
                                }}
                            />
                        </Col>
                        
                        <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                            <DatePicker
                                label="End Date"
                                value={get(data, "endDate") ? dayjs(get(data, "endDate")) : null}
                                onChange={(newValue) => {
                                    handleUpdateData('endDate', newValue ? newValue.toISOString() : null);
                                }}
                                inputFormat="MM-DD-YYYY"
                                minDate={getStartMintime(get(data, "startDate"))} // Fixed: Use startDate to restrict endDate
                                defaultValue={null}
                                slotProps={{
                                    textField: {
                                        id: "endDate",
                                        variant: 'outlined',
                                        size: 'small',
                                        InputLabelProps: {
                                            shrink: true,
                                        }
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                    <Row className='mt-10px'>
                         <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                             {data?.role === "admin" ? (
                                <RenderChangeUserSubRole  user={data} />
                             ) : null}

                             </Col>
                    </Row>
                    {get(data, "role") === "teacher" && isClaver && !editing && (<Row className='fixAdminInput' style={{ marginTop: 12 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={loading}
                            onClick={(e) => {
                                e.preventDefault()
                                let uc = cloneDeep(userClasses)
                                uc.push({})
                                setuserClasses(uc)
                            }} style={{ marginRight: '8px', width: 200, textTransform: 'inherit' }}>
                            Add Cources
                        </Button>
                    </Row>)}

                  
                    {get(data, "role") === "teacher" && isClaver && !editing && (userClasses.map((selectedCourse, i) => (<Row className='fixAdminInput' style={{ marginTop: 10 }}><Col span={12} style={{ paddingRight: 10 }}>
                        <FormControl variant="outlined">
                            <InputLabel id="cleverCourseLever"
                            // className={"schoolForm"}
                            >Select Cources for clever</InputLabel>
                            <Select
                                labelId="cleverCourseLever"
                                id="cleverCourse"
                                onChange={e => {
                                    const crs = find(cleverCources, ["id", e.target.value])
                                    let uc = cloneDeep(userClasses)
                                    uc[i] = { ...uc[i], ...crs };

                                    setuserClasses(uc)
                                }}
                                value={get(selectedCourse, 'id', '')}
                            // className={"schoolForm"}
                            >
                                <MenuItem key={"selectcr"} value={''} >
                                    {"Select cources"}
                                </MenuItem>
                                {cleverCources.map(cources => (
                                    <MenuItem key={cources.id} value={cources.id} >
                                        {cources.displayName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Col>
                        <Col span={6} style={{ paddingLeft: 10 }} className={"floatingLabelBG"}>
                            <TextField
                                id="cleverId"
                                label="Clever Id"
                                variant="outlined"
                                value={get(selectedCourse, 'cleverId', '')}
                                className={"districForm"}
                                onChange={(e) => {
                                    let uc = cloneDeep(userClasses)
                                    uc[i] = { ...uc[i], cleverId: e.target.value };
                                    setuserClasses(uc)
                                }}
                            />
                        </Col>
                        <Col span={6} style={{ paddingLeft: 10 }}>
                            <Button variant="contained" color="secondary"
                                // className={"schoolForm"}
                                onClick={(e) => {
                                    let uc = cloneDeep(userClasses)
                                    uc.splice(i, 1)
                                    setuserClasses(uc)

                                }}
                                style={{ marginRight: '8px', width: 100, textTransform: 'inherit' }}>
                                remove
                            </Button>
                        </Col>
                    </Row>))
                    )}

                    {!isClaver && showBooks &&   get(data, "role") == "teacher"  &&
                        <><Row className='fixAdminInput' gutter={[24, 24]} style={{ width: '100%', marginTop: 12 }}>
                            <InputLabel id="bookList-label" className={"schoolForm"}>Books by user</InputLabel>
                            <FormControl className={classes.formControl}>
                                <BookSection>
                                    <SelectableBookByGroup  
                                    books_group={selectedBook ? selectedBook : []}
                                     onSelect={(item) => {
                                        handleChangeMultiSelect(item)
                                    }} 
                                    org_book_permissions={bookPermissions_group||[]}
                                    from="admin" />
                            </BookSection>
                            {!editing && (<>
                                {booksError &&
                                    <FormHelperText error>Choose at least one book</FormHelperText>
                                }
                            </>)}
                            </FormControl>
                        </Row>
                        </>
                    }
                    {noLicensesError &&
                        <FormHelperText error>The selected school does not have enough licenses available</FormHelperText>
                    }
                    {!!createUserError &&
                        <FormHelperText error>{createUserError}</FormHelperText>
                    }
                    <Row className='fixAdminInput' gutter={[24, 24]} style={{ width: '100%', marginTop: 40 }}>
                        <Col span={4}>
                            <Button
                                disabled={loading || booksError || noLicensesError || gradeError || lastNameError || lastNameCharError || firstNameError || firstNameCharError || passwordError || formatPasswordError  || parentStdError || checkClassExistOrNot || emailError || schoolError}
                                variant="contained" color="primary" style={{ marginRight: '8px', width: '100%' }} type='submit'>
                                {loading ? <Loading size={20} white /> : (editing ? 'Update' : 'Create')}
                            </Button>
                        </Col>
                        {(editing) && (
                            <>
                                <Col span={4}>
                                    <Button variant="outlined" color="inherit" sx={{whiteSpace: "nowrap"}} disabled={loading} onClick={() => { showChangePassword() }} style={{ marginRight: '8px', width: '100%', textTransform: 'inherit' }}>
                                        Change password
                                    </Button>
                                </Col>
                            </>
                        )} {!onlyAdd && (
                            <>
                                <Col span={4}>
                                    <Button variant="contained" color="secondary"
                                        // className={"schoolForm"}
                                        onClick={() => navigateToDataBrowser()} style={{ marginRight: '8px', width: '100%', textTransform: 'inherit' }}>
                                        Cancel
                                    </Button>
                                </Col>
                            </>
                        )}
                    </Row>
                </Wrapper>
            )}
        </>
    );
};

const mapStateToProps = (state) => ({
    currentUser: state.currentUser
});

export default connect(mapStateToProps, null)(UserForm);